export function tagsStop(bar, side, stopPrice) {
  if (!bar || !Number.isFinite(stopPrice)) return false;
  return side === 'long' ? bar.low <= stopPrice : bar.high >= stopPrice;
}

export function tagsTarget(bar, side, price) {
  if (!bar || !Number.isFinite(price)) return false;
  return side === 'long' ? bar.high >= price : bar.low <= price;
}

export function tagsLimit(bar, side, limitPrice) {
  if (!bar || !Number.isFinite(limitPrice)) return false;
  if (side === 'long') return bar.low <= limitPrice || bar.open <= limitPrice;
  return bar.high >= limitPrice || bar.open >= limitPrice;
}

export function limitFillPrice(bar, side, limitPrice) {
  if (!Number.isFinite(limitPrice)) return bar.open;
  if (side === 'long') {
    return bar.open < limitPrice ? bar.open : limitPrice;
  }
  return bar.open > limitPrice ? bar.open : limitPrice;
}

export function resolveStopPrice(side, entryPrice, { stopPrice, atr, atrMultiple } = {}) {
  if (Number.isFinite(stopPrice)) return stopPrice;
  const dist = Number.isFinite(atr) && Number.isFinite(atrMultiple) ? Math.abs(atr * atrMultiple) : null;
  if (!Number.isFinite(dist) || dist <= 0) return null;
  return side === 'long' ? entryPrice - dist : entryPrice + dist;
}

export function resolveTakeProfitPrice(side, entryPrice, rValue, rMultiple) {
  if (!Number.isFinite(rValue) || !Number.isFinite(rMultiple)) return null;
  return side === 'long' ? entryPrice + rValue * rMultiple : entryPrice - rValue * rMultiple;
}
